module.exports = __webpack_public_path__ + "img/06.b0efa422.jpg";